<template>
<v-container>
    <h1 class="title mb-3 text-center">HSDQ vragenlijst</h1>
    <v-stepper v-model="e1" class="mb-5">
      <v-stepper-header>
        <template> 
          <v-divider v-if="e1 > 1" ></v-divider>
          <v-stepper-step :complete="steps[e1 -1] ==  null || steps[e1 -1].answer > 0" :step="e1"></v-stepper-step>
          <v-divider v-if="e1 < steps.length + 1" ></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items class="questionaire">
          <v-stepper-content :step="step.id" v-for="(step, n) in steps" :key="n">
                <v-container fill-height>
                  <v-layout row wrap align-center>
                    <v-flex class="text-center">
                      <p>Vraag {{step.id}} / {{steps.length}}</p>
                      <h3 class="mb-5" v-html="step.question"></h3>
                      <v-rating 
                          v-model="step.answer"
                          :dense="$vuetify.breakpoint.xs"
                          x-large
                          @input="select">
                          <template v-slot:item="props">
                          <v-icon
                            :color="props.isFilled ? 'white' : 'grey lighten-1'"
                            large
                            @click="props.click" >
                            {{ props.isFilled ? 'mdi-star-circle' : 'mdi-circle-outline' }}
                          </v-icon>
                        </template>
                      </v-rating>
                      <v-flex class="d-flex justify-space-between">
                        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                        <small class="text-left">{{step.min}}</small>
                        <v-spacer></v-spacer>
                        <small class="text-right">{{step.max}}</small>
                        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-container>
          </v-stepper-content>
          <v-stepper-content :step="steps.length + 1">
            <v-container fill-height>
              <v-layout row wrap align-center class="pa-3">
                <v-flex class="text-center">
                  <h3 class="mb-5 title" >Uw Score</h3>
                  <p class="display-2">{{score.toFixed(2)}}</p>
                  <p v-if="score <= 2.02">Er is geen sprake van een mogelijke slaapstoornis.</p>
                  <p v-if="score > 2.02">Er is mogelijk sprake van een slaapstoornis. Raadpleeg uw huisarts<span v-if="insomnia >= 3.68"> of schakel een expert in</span>.</p>
                </v-flex>
              </v-layout>
            </v-container>
              
            <div class="text-center mb-3" >
              <v-card raised v-if="score > 2.02">
                <v-card-title><h4>Scoringstabel</h4></v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item v-if="insomnia >= 3.68">
                    <v-list-item-content class="text-left">Insomnia:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ insomnia.toFixed(2) }} (3.68)</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="parasomnia >= 2.42">
                    <v-list-item-content class="text-left">Parasomnia:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ parasomnia.toFixed(2) }} (2.42)</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="crsd >= 3.41">
                    <v-list-item-content class="text-left">CRSD:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ crsd.toFixed(2) }} (3.41)</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="hypersomnolentie >= 2.90">
                    <v-list-item-content class="text-left">Hypersomnolentie:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ hypersomnolentie.toFixed(2) }} (2.90)</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="rlslms >= 2.7">
                    <v-list-item-content class="text-left">RLS-LMS:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ rlslms.toFixed(2) }} (2.7)</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="sbd >= 2.87">
                    <v-list-item-content class="text-left">SBD:</v-list-item-content>
                    <v-list-item-content class="align-end">{{ sbd.toFixed(2) }} (2.87)</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
              <email name="HSDQ" :steps="steps" :score="score" color="primary"></email><br/>
              <expert v-if="insomnia >= 3.68" color="warning"></expert>
            </div>
          </v-stepper-content>
      </v-stepper-items>
  </v-stepper>
  <div class="text-center mb-5">
    <v-btn dark @click="reset">Opnieuw beginnen</v-btn>
  </diV>
  <v-alert color="primary" outlined >
    <p><strong>Wilt u voor elk van de 32 uitspraken aangeven in hoeverre deze op u van toepassing zijn?</strong></p>
    <p>Geef één van de antwoordmogelijkheden (aantal sterren):</p>
    <ol>
      <li>helemaal niet van toepassing</li>
      <li>meestal niet van toepassing</li>
      <li>soms wel, soms niet van toepassing</li>
      <li>meestal wel van toepassing</li>
      <li>helemaal wel van toepassing</li>
    </ol>
    <br />
    <ul>
      <li>Sla geen vragen over.</li>
      <li>Ga er bij het beantwoorden van uit dat het om de <i><strong>afgelopen 3 maanden</strong></i> gaat.</li>
      <li>Ook al weet u het misschien niet van uzelf (bijvoorbeeld of u snurkt of met uw benen beweegt), geef dan aan wat u van uw partner gehoord heeft of hoe u denkt dat het is.</li>
    </ul>
  </v-alert>
</v-container>
</template>

<script>
import Email from '@/components/questionaires/email';
import Expert from '@/components/Expert';
  export default {
    name: "hsdq-questionaire",
    components: {
      Email,
      Expert
    },
    data () {
      return {
        e1:1,
        completed: false,
        steps: [
          {
            id: 1,
            question: "Ik heb overdag last van vermoeidheid.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 2,
            question: "Wanneer ik in bed ga liggen heb ik een vervelend kriebelig, brandend of jeukend gevoel in mijn benen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 3,
            question: "Ik word 's morgens met een droge mond wakker.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 4,
            question: "Ik word 's nachts plotseling wakker, met een schreeuw en/of hevig transpirerend, en maak een angstige indruk.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 5,
            question: "Ik val pas tegen de ochtend in slaap en heb dan grote moeite om 's morgens bijtijds wakker te worden. In het weekeinde slaap ik lang uit.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 6,
            question: "Als ik “rusteloze benen” heb, kan ik dit gevoel onderdrukken door te lopen of mijn benen te strekken.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 7,
            question: "De kwaliteit van mijn slaap is slecht en ik voel me 's morgens dan ook niet uitgerust.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 8,
            question: "Als ik rustig zit, vooral 's avonds, voel ik de drang om mijn benen te bewegen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 9,
            question: "Tijdens mijn slaap lig ik met mijn benen of armen te bewegen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 10,
            question: "Ik lig 's nachts lang wakker.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 11,
            question: "Tijdens mijn slaap heb ik last van schoppende beenbewegingen die ik onmogelijk kan onderdrukken.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 12,
            question: "Ik maak me zorgen over de gevolgen van mijn slechte slaap (bijvoorbeeld voor mijn gezondheid).",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 13,
            question: "Ik kan 's avonds moeilijk in slaap komen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 14,
            question: "Vooral na een slechte nacht heb ik overdag last van 1 of meer van deze gevolgen: vermoeidheid, slaperigheid, slecht humeur, zwakke concentratie, geheugen- problemen, gebrek aan energie.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 15,
            question: "Ik krijg onvoldoende slaap, ondanks dat ik volop gelegenheid heb om lang te slapen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 16,
            question: "Ik heb regelmatig een levendige droom waarin ik word aangevallen en me dan verdedig met wilde bewegingen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 17,
            question: "Ik stop met ademen tijdens mijn slaap.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 18,
            question: "Ik snurk luid tijdens mijn slaap.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 19,
            question: "Ik schrik 's nachts wakker met het gevoel te stikken.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 20,
            question: "Ik heb last van nachtmerries of angstige dromen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 21,
            question: "Omdat ik te weinig slaap krijg, functioneer ik overdag minder goed.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 22,
            question: "Ik heb mezelf tijdens mijn slaap wel eens verwond, zonder me dat achteraf te herinneren.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 23,
            question: "In de loop van de dag val ik herhaaldelijk in slaap.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 24,
            question: "Ik word regelmatig verward halfwakker en maak dan slaande bewegingen. Ik herinner mij er later vrijwel niets van.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 25,
            question: "Na een dutje overdag voel ik me niet uitgerust.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 26,
            question: "Ik slaap slecht omdat het me niet lukt om op een normale tijd in te slapen en 's morgens op een normale tijd wakker te worden.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 27,
            question: "Als ik 's nachts wakker moet blijven, slaap ik overdag slecht.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 28,
            question: "Ik slaap 's nachts gewoonlijk meer dan 10 uur, heb moeite om 's morgens wakker te worden en doe overdag ook dutjes.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 29,
            question: "Ik schrik ’s nachts wakker met het gevoel te stikken.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 30,
            question: "Mijn tijd van inslapen wisselt sterk van dag tot dag.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 31,
            question: "Ik heb last van slaapwandelen.",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          },
          {
            id: 32,
            question: "Ik val overdag ongewild in slaap, vooral in een saaie situatie (bijvoorbeeld bij een saai tv-programma).",
            min: "Helemaal NIET van toepassing",
            max: "Helemaal WEL van toepassing",
            answer: 0
          }
        ]
      }
    },
    methods: {
      reset() {
        this.steps.forEach((s) => { return s.answer = 0 });
        this.e1 = 1;
      },
      select(value)
      {
        this.steps[this.e1 - 1].answer = value;
        setTimeout(() => {
          this.e1++;
          if(this.e1 > this.steps.length)
          {
            this.completed = true;
            this.save();
          }
        }, 100);
      },
      save()
      {
        let q = {
          name: "HSDQ",
          score: this.score,
          json: JSON.stringify(this.steps)
        };
        
        this.$http.post("api/Questionaire", q);
      }
    },
    computed: {
      insomnia() {
        return (this.steps[1 - 1].answer +
        this.steps[7 - 1].answer +
        this.steps[10 - 1].answer +
        this.steps[12 - 1].answer +
        this.steps[13 - 1].answer +
        this.steps[14 - 1].answer +
        this.steps[15 - 1].answer +
        this.steps[21 - 1].answer) / parseFloat(8);
      },
      parasomnia() {
        return (this.steps[4 - 1].answer +
        this.steps[16 - 1].answer +
        this.steps[20 - 1].answer +
        this.steps[22 - 1].answer +
        this.steps[24 - 1].answer +
        this.steps[31 - 1].answer) / parseFloat(6);
      },
      crsd() {
        return (this.steps[5 - 1].answer +
        this.steps[10 - 1].answer +
        this.steps[13 - 1].answer +
        this.steps[26 - 1].answer +
        this.steps[27 - 1].answer +
        this.steps[30 - 1].answer) / parseFloat(6);
      },
      hypersomnolentie() {
        return (this.steps[23 - 1].answer +
        this.steps[25 - 1].answer +
        this.steps[28 - 1].answer +
        this.steps[29 - 1].answer +
        this.steps[32 - 1].answer) / parseFloat(5);
      },
      rlslms() {
        return (this.steps[2 - 1].answer +
        this.steps[6 - 1].answer +
        this.steps[8 - 1].answer +
        this.steps[9 - 1].answer +
        this.steps[11 - 1].answer) / parseFloat(5);
      },
      sbd() {
        return (this.steps[3].answer +
        this.steps[17].answer +
        this.steps[18].answer +
        this.steps[19].answer) / parseFloat(4);
      },
      score() {
        return this.steps.reduce((a, b) => { return a + b.answer }, 0) / parseFloat(32)
      }
    }
  }
</script>

<style scoped>
.questionaire {
  color: white;
  background-color: #46555e !important;
  border-color: #46555e !important;
}
</style>